import type {Option, FormkitSelectbox} from '~/types/formkitSelectbox';

export function getInputId(props: FormkitSelectbox, option: Option): string {
	return `${props.context.node.name}:${option.value}`;
}

export function isSelected(props: FormkitSelectbox, option: Option): boolean {
	return props.context._value?.includes(option.value) ?? false;
}
